<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 财务公司
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-form :model="query" ref="query" label-width="80px" inline="">
                    <el-form-item label="公司名称:" label-width="75px">
                        <el-input v-model="query.company_name" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
                    <el-button type="primary"  @click="resetsearch()">重置</el-button>
                </el-form>
            </div>
            <div class="next-box">
                <el-button
                    type="danger"
                    icon="el-icon-delete-solid"
                    @click="delAllSelection"
                >批量删除</el-button>
               
                <el-button
                    type="primary"
                    icon="el-icon-circle-plus"
                    @click="addVisiable= true"
                >添加</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="company_name" label="财务公司"  align="center"></el-table-column>
                <el-table-column prop="employ_id" label="所属员工id"  align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.employ_id==0">无</span>
                        <span v-else>{{scope.row.employ_id}}</span>
                    </template>
                </el-table-column>
                 <el-table-column label="旗下用户"  align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="lookUser(scope.$index, scope.row)"
                        >查看详情</el-button>
                    </template>
                 </el-table-column>
                <el-table-column prop="username" label="账号"  align="center"></el-table-column>
                <el-table-column prop="password" label="密码"  align="center"></el-table-column>
                <el-table-column prop="nickname" label="财务公司管理员"  align="center"></el-table-column>
                <el-table-column prop="company_commission" label="财务公司折扣(%)"  align="center">
                    <template slot-scope="scope">
                       <span>{{scope.row.company_commission}}%</span>
                    </template>
                </el-table-column>
                <el-table-column prop="employ_commission" label="所属员工抽成(%)"  align="center">
                     <template slot-scope="scope">
                       <span>{{scope.row.employ_commission}}%</span>
                    </template>
                </el-table-column>
                <el-table-column prop="k_money" label="可提现金额"  align="center"></el-table-column>
                <el-table-column prop="y_money" label="已提现金额"  align="center"></el-table-column>
                <el-table-column prop="count_money" label="总提成"  align="center"></el-table-column>
                <el-table-column prop="create_time" label="创建时间"  align="center" width="180px"></el-table-column>
                <el-table-column  prop="disable" label="状态" align="center" >
                    <template slot-scope="scope">
                        <i
                        :class="scope.row.disable==0?'el-icon-circle-check':(scope.row.disable==1?'el-icon-circle-close':'')"
                        :style="scope.row.disable==0?'color:green':(scope.row.disable==1?'color:red':'')"
                        ></i>
                    </template>
                </el-table-column>
                       
                <el-table-column label="操作" width="300" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>
                        <el-button size="mini"
                            :type="scope.row.disable==0?'warning':(scope.row.disable==1?'success':'')"
                            :icon="scope.row.disable==0?'el-icon-error':(scope.row.disable==1?'el-icon-success':'')"
                            @click="updateStatus(scope.$index,scope.row)"
                        >
                        <span v-if="scope.row.disable==0">禁用</span>
                        <span v-else>启用</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
         <!-- 添加弹出框 -->
        <el-dialog title="创建财务公司" :visible.sync="addVisiable" width="700px">
            <el-form ref="addForm" :rules="rules" :model="addForm" label-width="130px" >
                <el-form-item prop="company_name" label="公司名">
                    <el-input v-model="addForm.company_name"></el-input>
                </el-form-item>
                <el-form-item prop="username" label="账号">
                    <el-input v-model="addForm.username"></el-input>
                </el-form-item>
                <el-form-item prop="password" label="密码">
                    <el-input v-model="addForm.password"></el-input>
                </el-form-item>
                <el-form-item prop="company_commission" label="财务公司折扣(%)">
                    <el-input v-model="addForm.company_commission"></el-input>
                </el-form-item>
                <el-form-item prop="openid" label="财务公司管理员">  
                    <el-select v-model="addForm.openid" filterable>
                        <el-option
                            v-for="item in userList1"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="employ_id" label="所属员工">
                    <el-select v-model="addForm.employ_id" filterable>
                        <el-option
                            v-for="item in workList"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="employ_commission" label="员工抽成(%)">
                    <el-input v-model="addForm.employ_commission"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisiable = false">取 消</el-button>
                <el-button type="primary" @click="addData()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 编辑弹出框 -->
        <el-dialog title="编辑财务公司" :visible.sync="editVisible" width="700px">
            <el-form ref="editForm" :rules="rules" :model="editForm" label-width="135px" >
                <el-form-item prop="company_name" label="公司名">
                    <el-input v-model="editForm.company_name"></el-input>
                </el-form-item>
                <el-form-item prop="username" label="账号">
                    <el-input v-model="editForm.username"></el-input>
                </el-form-item>
                <el-form-item prop="password" label="密码">
                    <el-input v-model="editForm.password"></el-input>
                </el-form-item>
                <el-form-item prop="company_commission" label="财务公司折扣(%)">
                    <el-input v-model="editForm.company_commission"></el-input>
                </el-form-item>
                <el-form-item prop="user_id" label="管理员">  
                    <el-select v-model="editForm.user_id" filterable>
                        <el-option
                            v-for="item in userList1"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="employ_commission" label="所属员工抽成(%)">
                    <el-input v-model="editForm.employ_commission"></el-input>
                </el-form-item>
                <el-form-item prop="employ_id" label="所属员工">
                    <el-select v-model="editForm.employ_id" filterable>
                        <el-option
                            v-for="item in workList"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
               </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit()">确 定</el-button>
            </span>
        </el-dialog>
         <!-- 旗下用户 -->
        <el-dialog title="旗下用户" :visible.sync="userVisiable" width="900px">
            <div class="handle-box">
                <el-form :model="search" ref="search" label-width="80px" inline="">
                    <el-form-item label="用户昵称:" label-width="75px">
                        <el-input v-model="search.nickname" placeholder="请输入" class="handle-input mr10" @input="getFiSearch()"></el-input>
                    </el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getFiSearch()">搜索</el-button>
                    <el-button type="primary"  @click="resetsearch1()">重置</el-button>
                </el-form>
            </div>
            <el-table
                :data="fiUserList"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="openid" label="openid"  align="center" width="200px"></el-table-column>
                <el-table-column prop="nickname" label="用户昵称"  align="center"></el-table-column>
                <el-table-column prop="sex" label="性别"  align="center"></el-table-column>
                <el-table-column prop="headimgurl" label="头像"  align="center">
                    <template slot-scope="scope">
                        <el-image
                            class="table-td-thumb"
                            :src="scope.row.headimgurl"
                           
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间"  align="center" width="200px"></el-table-column>
                <el-table-column prop="employ_id" label="所属员工id"  align="center"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="search.pageIndex"
                    :page-size="search.pageSize"
                    :total="pageTotalFi"
                    @current-change="handlePageChange1"
                ></el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>


import { post } from '../../../api/request';

export default {
    name: 'basetable',

    data() {
         var company_commission = (rule, value, callback) => {
            const reg = /^\d+.?\d{0,2}$/
            if (!value) {
                callback(new Error('请输入抽成'))
            } else if (!Number(value)) {
                callback(new Error('请输入数字值'))
            } else if(value<=0||value>100){
                callback(new Error('请输入大于0小于100的抽成'))
            }else {
                if (reg.test(value)) {
                callback()
                } else {
                callback(new Error('小数点后最多只能输入两位'))
                }
            }
        }
         var employ_commission = (rule, value, callback) => {
            const reg = /^\d+.?\d{0,2}$/
            if (!Number(value)&&value!="") {
                callback(new Error('请输入数字值'))
            } else if(value<=0&&value!=""||value>100&&value!=""){
                callback(new Error('请输入大于0小于100的抽成'))
            }else {
                if (reg.test(value)&&value!="") {
                callback()
                } 
                else if(value!="") {
                callback(new Error('小数点后最多只能输入两位'))
                }
            }
        }
        return {
            id1:"",
            userList1:[],
            loading: false,
            options:[],
            fineceId:"",
            fiUserList:[],//财务公司旗下用户
            userVisiable: false,
            companyid:'',//当前公司id
            //搜索数据
            workList:[],
            tableData: [],
            query: {
                company_name: '',
                pageIndex: 1,
                pageSize: 8,
            },
            search:{
                nickname: '',
                pageIndex: 1,
                pageSize: 8,
            },
            pageTotalFi:0,
            pageTotal: 7,
            //添加数据
            addVisiable:false,
            addForm:{
                company_name:'',
                username:'',
                password:'',
                employ_id:"",
                openid:'',
                company_commission:"",
                employ_commission:"",
            },
            //编辑数据
            editVisible:false,
            editForm:{},
            //添加数据表单验证
            rules: {
                company_name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
                username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                company_commission: [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
            },
            //批量删除
            multipleSelection: [],
            delList: [],
            //获取id
            idx: -1,
            id: -1
        };
    },
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
        this.getList()
        this.getUserList()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
        this.getList()
        this.getUserList()
    },
    methods: {
         remoteMethod(query) {
            if (query !== '') {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
                this.options = this.list.filter(item => {
                return item.label.toLowerCase()
                    .indexOf(query.toLowerCase()) > -1;
                });
            }, 200);
            } else {
            this.options = [];
            }
        },
        getUserList(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            post("admin/financecpy/seluser",formdata).then(res=>{
                if(res.code=200){
                    this.userList1 = res.data.data;
                }
                else{
                    this.$message.error("暂无数据")
                }
            })
        },
        lookUser(index,row){
            this.userVisiable = true
            let formdata = new FormData()
            this.fineceId = row.id
            formdata.append('id',row.id)
            formdata.append('nickname',this.search.nickname)
            formdata.append('page',this.search.pageIndex)
            formdata.append('limit',this.search.pageSize)
            post("admin/user/finUser",formdata).then(res=>{
           
                this.fiUserList = res.data.data.list
                this.pageTotalFi = res.data.data.num
                  
            })
        },
        getFi(){
            let formdata = new FormData()
            formdata.append('id',this.fineceId)
            formdata.append('nickname',this.search.nickname)
            formdata.append('page',this.search.pageIndex)
            formdata.append('limit',this.search.pageSize)
            post("admin/user/finUser",formdata).then(res=>{
                this.fiUserList = res.data.data.list
                this.pageTotalFi = res.data.data.num
            })
        },
        getFiSearch(){
            let formdata = new FormData()
            formdata.append('id',this.fineceId)
            formdata.append('nickname',this.search.nickname)
            formdata.append('page',1)
            formdata.append('limit',this.search.pageSize)
            post("admin/user/finUser",formdata).then(res=>{
                this.fiUserList = res.data.data.list
                this.pageTotalFi = res.data.data.num
            })
        },
        getList(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('page',1)
            formdata.append('limit',1000)
            post('admin/employees/employinfo',formdata).then(res => {
                if(res.code=200){
                    this.workList = res.data.data.list;
               
                    this.pageTotal = res.data.data.num
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        addData(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('company_name',this.addForm.company_name)
            formdata.append('username',this.addForm.username)
            formdata.append('password',this.addForm.password)
            formdata.append('employ_id',this.addForm.employ_id)
            formdata.append('openid',this.addForm.openid)
            formdata.append('employ_commission',this.addForm.employ_commission)
            formdata.append('company_commission',this.addForm.company_commission)
            let url  = 'admin/financecpy/addfincpy'
            this.$refs['addForm'].validate((valid) => {
            if (valid) {
                post(url,formdata).then(res=>{
                    if(res.data.msg =="创建成功"){
                        this.$message.success("创建成功")
                        this.getData()
                        this.$refs['addForm'].resetFields();
                        this.addVisiable = false 
                        this.getUserList()
                        this.options = []
                    }
                    else if (res.data.msg="已存在该账号") {
                            this.$message.warning("已存在该账号")
                    }
                    else{
                        this.$messaga.error("创建失败")
                    }          
                })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        updateStatus(index,row){
            let formdata = new FormData()
            let url = 'admin/financecpy/disables'
            formdata.append('id',row.id)
            if(row.disable==1){
                url = 'admin/financecpy/starts'
            }
            post(url,formdata).then(res=>{
                if(res.data.msg =="禁用失败"){
                    this.$message.error("禁用失败")
                } 
                else if(res.data.msg =="禁用成功"){
                    this.$message.success("禁用成功")
                    this.getData()
                }
                else if(res.data.msg =="启用成功"){
                    this.$message.success("启用成功")
                    this.getData()
                }
                else if(res.data.msg =="启用失败"){
                    this.$message.error("启用失败")
                    this.getData()
                }      
            })
        },
        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        //重置搜索
        resetsearch(){
            this.query.type= '',
            this.getData()
        },
        resetsearch1(){
            this.search.nickname= '',
            this.getFiSearch()
        },
        // 获取后端接口数据
        getData() {
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('company_name',this.query.company_name)
            formdata.append('page',this.query.pageIndex)
            formdata.append('limit',this.query.pageSize)
            post('admin/financecpy/showFincpy',formdata).then(res => {
                if(res.code=200){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                    if (!this.tableData.length && this.query.pageIndex > 1) {
                        this.query.pageIndex--;
                        this.getData()
                    }
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        // 触发搜索按钮
        inputSearch(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('company_name',this.query.company_name)
            formdata.append('page',1)
            formdata.append('limit',this.query.pageSize)
            post('admin/financecpy/showFincpy',formdata).then(res => {
                if(res.data.data){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                }
            });
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let formdata = new FormData()
                    formdata.append('id',row.id)
                    post('admin/financecpy/delFincpy',formdata).then(res=>{
                        if(res.data.msg=="删除成功"){
                            this.$message.success('删除成功');
                                this.getData()
                        }
                        else
                            this.message.error('删除失败')
                    })
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].id + ',';
            }
            let formdata = new FormData()
            formdata.append('id',str)
            post('admin/financecpy/delFincpy',formdata).then(res=>{
                if(res.data.msg == "删除成功"){
                    this.multipleSelection = [];
                    this.$message.success('删除成功')
                        this.getData()
                }
                else{
                    this.$message.error('删除失败')
                }
            })
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
       
            this.editForm = Object.assign({}, row);
            console.log( this.editForm.user_id)
            this.editForm.company_commission =parseInt(this.editForm.company_commission)
            this.editForm.employ_commission =parseInt(this.editForm.employ_commission)
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    let formdata = new FormData()
                    formdata.append('id',this.editForm.id)
                    formdata.append('company_name',this.editForm.company_name)
                    formdata.append('username',this.editForm.username)
                    formdata.append('password',this.editForm.password)
                    formdata.append('employ_id',this.editForm.employ_id)
                    formdata.append('user_id',this.editForm.user_id)
                    formdata.append('employ_commission',this.editForm.employ_commission)
                    formdata.append('company_commission',this.editForm.company_commission)
                    post('admin/financecpy/upFincpy',formdata).then(res=>{
                        if(res.data.msg == "修改成功"){
                            this.getData()
                            this.$message.success('修改成功')
                            this.editVisible = false
                            this.getUserList()
                            this.options =[]
                        }
                        else{
                            this.$message.error('修改失败')
                        }
                    
                    })
                }
            })
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        handlePageChange1(val) {
            this.$set(this.search, 'pageIndex', val);
            this.getFi();
        }
    }
};
</script>

<style scoped>

.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.editor-btn{
    margin-top: 20px;
}
</style>
